import React, { useCallback, useEffect, useMemo, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
// import { RoutePath } from '../../../routes/Routes'
import { TextField, Typography } from '@mui/material'
import StateComponents from '../../../../components/state-component/StateComponents'
import { ContactApi, contactType } from '../../../../api/contact/contact.api'
import ContainerButton from '../../../../components/button/ContainerButton'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import { alertError, alertSuccess } from '../../../../components/alert/swal'
import { IconComponents } from '../../../../assets/icons/icons'
import { SocialMediaApi } from '../../../../api/social-media/social_media.api'
import GoogleMapLocation from '../../../../components/google-map-api/GoogleMapApiCustom'
import { RootState } from '../../../../store/store'
import { checkPermission } from '../../../../utils/app.utils'
import { routeName } from '../../../../routes/routeName'
import { debounce } from 'lodash'
import { useTranslation } from 'react-i18next'

type Props = {}



const ContactStructure: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // const profileReducer = useSelector((state: RootState) => state.profile.profile);
    // const permission: any[] = profileReducer?.permission || [];
    // const checkPermit = checkPermission('website_structure_contact', permission);
    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_CONTACT', permission);

    const [id_contact, set_id_contact] = useState<number | null>(null);
    const [formState, setFormState] = useState<contactType>({
        contact_address: "",
        contact_name: "",
        contact_suggestions: "",
        contact_tel: "",
        latitude: "",
        longitude: ""
    })
    const [latitude, set_latitude] = useState<string>("");
    const [longitude, set_longitude] = useState<string>("");

    const [socialMediaData, setSocialMediaData] = useState<{
        icon: React.ReactNode,
        title_name: string,
        link: string,
        id_social_media: number
    }[]>([
        {
            icon: <IconComponents.FacebookIcon />,
            link: "",
            title_name: "facebook",
            id_social_media: 0
        },
        {
            icon: <IconComponents.InstagramIcon />,
            link: "",
            title_name: "instagram",
            id_social_media: 0
        },
        {
            icon: <IconComponents.XIcon />,
            link: "",
            title_name: "x",
            id_social_media: 0
        },
        {
            icon: <IconComponents.LineIcon />,
            link: "",
            title_name: "line",
            id_social_media: 0
        },
        {
            icon: <IconComponents.YoutubeIcon />,
            link: "",
            title_name: "youtube",
            id_social_media: 0
        },
    ]);

    const handleChangeFormState = (field: keyof contactType, value: string) => {
        setFormState((prev) => ({ ...prev, [field]: value }))
    }
    const handleChangeSocialMedia = (field: 'link', value: string, index: number) => {
        setSocialMediaData((prev) => prev?.map((list, i) => {
            return i === index ? {
                ...list,
                [field]: value
            } : list
        }))
    }


    const handleGetData = async () => {
        dispatch(setLoading());
        await ContactApi.findOne().then((res) => {
            if (res.status < 300) {
                const contact_detail = res.data?.data?.contact || null;
                const social_media: any[] = res.data?.data?.social_media || null;
                set_id_contact(contact_detail?.id_contact || null)
                setFormState((prev) => ({
                    ...prev,
                    contact_address: contact_detail?.contact_address,
                    contact_name: contact_detail?.contact_name,
                    contact_suggestions: contact_detail?.contact_suggestions,
                    contact_tel: contact_detail?.contact_tel,
                    latitude: contact_detail?.latitude,
                    longitude: contact_detail?.longitude
                }))
                set_latitude(contact_detail?.latitude)
                set_longitude(contact_detail?.longitude)
                setSocialMediaData((prev) => {
                    return prev?.map((list) => {
                        return {
                            ...list,
                            id_social_media: social_media?.find((x) => x?.social_media_name === list?.title_name)?.id_social_media,
                            title_name: social_media?.find((x) => x?.social_media_name === list?.title_name)?.social_media_name,
                            link: social_media?.find((x) => x?.social_media_name === list?.title_name)?.social_media_link,
                        }
                    })
                })
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading())
        })
    }

    const generateBodySocialMedia = () => {
        return socialMediaData?.map(async (list) => {
            await SocialMediaApi.update(list?.id_social_media, {
                social_media_link: list?.link,
                social_media_name: list?.title_name
            }).catch((err) => {
                console.log(err)
                throw err
            })
        })
    }
    const handleSubmit = async () => {
        const body_social_media = generateBodySocialMedia();
        dispatch(setLoading());
        await Promise.all(body_social_media).catch((err) => {
            alertError(t("เกิดข้อผิดพลาด"))
            dispatch(unsetLoading());
            throw err
        });
        if (id_contact) {
            await ContactApi.update(id_contact, {
                ...formState,
                latitude: latitude,
                longitude: longitude
            }).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    alertSuccess(t("อัพเดตข้อมูล"), t("อัพเดตข้อมูล สำเร็จ"));
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("อัพเดตข้อมูล"), t("อัพเดตข้อมูล ไม่สำเร็จ"));
            }).finally(() => {
                dispatch(unsetLoading())
            })
        } else {
            await ContactApi.create({
                ...formState,
                latitude: latitude,
                longitude: longitude
            }).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    alertSuccess(t("อัพเดตข้อมูล"), t("อัพเดตข้อมูล สำเร็จ"));
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("อัพเดตข้อมูล"), t("อัพเดตข้อมูล ไม่สำเร็จ"));
            }).finally(() => {
                dispatch(unsetLoading())
            })
        }
    }

    useEffect(() => {
        handleGetData();
    }, [])

    const debouncedUpdateLocation = useCallback(
        debounce((lat: number, lng: number) => {
            set_latitude(String(lat));
            set_longitude(String(lng));
        }, 400),
        []
    );
    const handleMapClick = useCallback((e: { lat?: number, lng?: number }) => {
        const { lat: clickedLat, lng: clickedLng } = e;
        if (clickedLat && clickedLng) {
            debouncedUpdateLocation(clickedLat, clickedLng);
        }
    }, [debouncedUpdateLocation]);

    const lat = useMemo(() => +latitude || 0, [latitude]);
    const lng = useMemo(() => +longitude || 0, [longitude]);

    const MemoizedGoogleMap = useMemo(() => (
        <GoogleMapLocation
            lat={lat}
            lng={lng}
            onClick={handleMapClick}
        />
    ), [lat, lng, handleMapClick]);

    return (
        <ContainerLayout
            title=''
            titleName={t('จัดการช่องทางติดต่อ')}
            navigateContent={
                <NavigateListCustom
                    navigateData={
                        [
                            {
                                key: "โครงสร้างเว็บไซต์", // i18n-ignore
                                name: t("โครงสร้างเว็บไซต์"),
                                pathName: "",
                                disabled_match: true
                            },
                            {
                                key: "จัดการช่องทางติดต่อ", // i18n-ignore
                                name: t("จัดการช่องทางติดต่อ"),
                                pathName: routeName.cms_website.website_structure_contact,
                            },
                        ]}
                />
            }
            buttonContent={
                <ContainerButton
                    justifyContent='flex-end'
                    buttonData={[
                        {
                            seq: 1,
                            buttonProps: {
                                onClick: () => navigate(-1)
                            },
                            key: "BACK",
                            label: t("ย้อนกลับ"),
                            type: "BACK"
                        },
                        {
                            seq: 2,
                            hidden: !checkPermit.isUpdate,
                            buttonProps: {
                                onClick: handleSubmit
                            },
                            key: "SAVE",
                            label: t("บันทึก"),
                            type: "SAVE"
                        },
                    ]}
                />
            }
            content={
                <div className='w-full flex flex-col md:flex-row gap-6'>
                    <span className='w-full flex flex-col'>
                        <Typography variant='h6'>
                            {t("ข้อมูลที่ตั้ง")}
                        </Typography>
                        <div className='w-full'>
                            {latitude && longitude && MemoizedGoogleMap}
                        </div>
                    </span>
                    <span className='w-full flex flex-col'>
                        <StateComponents
                            otherProps={{ spacing: 5 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                    },
                                    fieldProps: {
                                        heading: t("ชื่อที่ตั้ง"),
                                        placeholder: t("ระบุ"),
                                        value: formState.contact_name,
                                        onChange: (e) => handleChangeFormState('contact_name', e.target.value)
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                    },
                                    fieldProps: {
                                        heading: t("ที่อยู่"),
                                        placeholder: t("ระบุ"),
                                        value: formState.contact_address,
                                        onChange: (e) => handleChangeFormState('contact_address', e.target.value)
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "TEXT-MASK",
                                    gridProps: {
                                        xs: 12,
                                        md: 6
                                    },
                                    fieldProps: {
                                        mode: "phone",
                                        heading: t("โทรศัพท์"),
                                        placeholder: t("ระบุ"),
                                        value: formState.contact_tel,
                                        onChange: (e) => handleChangeFormState('contact_tel', e.target.value)
                                    }
                                },
                                {
                                    seq: 4,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 6
                                    },
                                    fieldProps: {
                                        heading: t("อีเมล"),
                                        placeholder: t("ระบุ"),
                                        value: formState.contact_suggestions,
                                        onChange: (e) => handleChangeFormState('contact_suggestions', e.target.value)
                                    }
                                },
                                {
                                    seq: 6,
                                    type: "TEXT-MASK",
                                    gridProps: {
                                        xs: 12,
                                        md: 6
                                    },
                                    fieldProps: {
                                        mode: 'latlng',
                                        heading: t("ละติจูด"),
                                        placeholder: t("ระบุ"),
                                        value: formState.latitude,
                                        onChange: (e) => handleChangeFormState('latitude', e.target.value)
                                    }
                                },
                                {
                                    seq: 7,
                                    type: "TEXT-MASK",
                                    gridProps: {
                                        xs: 12,
                                        md: 6
                                    },
                                    fieldProps: {
                                        mode: 'latlng',
                                        heading: t("ลองจิจูด"),
                                        placeholder: t("ระบุ"),
                                        value: formState.longitude,
                                        onChange: (e) => handleChangeFormState('longitude', e.target.value)
                                    }
                                },
                            ]}
                        />

                        <Typography mt={2} variant='h5'>
                            Social Media
                        </Typography>
                        <div className='w-full flex flex-col gap-5 mt-4'>
                            {socialMediaData?.map((list, index) => {
                                return (
                                    <span className='w-full flex gap-4 justify-start items-center' key={list.title_name}>
                                        <div className='w-full max-w-[120px] flex gap-4'>
                                            <div>
                                                {list.icon}
                                            </div>
                                            <div>
                                                {list.title_name}
                                            </div>
                                        </div>
                                        <div className='flex-1'>
                                            <TextField
                                                className='w-full'
                                                placeholder={t('ระบุ')}
                                                value={list?.link}
                                                onChange={(e) => handleChangeSocialMedia('link', e.target.value, index)}
                                            />
                                        </div>
                                    </span>
                                )
                            })}
                        </div>
                    </span>
                </div>
            }
        />
    )
}

export default ContactStructure